var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 5.33334H11.3333M4.66667 8.00001H7.33333M8 13.3333L5.33333 10.6667H3.33333C2.97971 10.6667 2.64057 10.5262 2.39052 10.2761C2.14048 10.0261 2 9.68696 2 9.33334V4.00001C2 3.64638 2.14048 3.30724 2.39052 3.0572C2.64057 2.80715 2.97971 2.66667 3.33333 2.66667H12.6667C13.0203 2.66667 13.3594 2.80715 13.6095 3.0572C13.8595 3.30724 14 3.64638 14 4.00001V9.33334C14 9.68696 13.8595 10.0261 13.6095 10.2761C13.3594 10.5262 13.0203 10.6667 12.6667 10.6667H10.6667L8 13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationOutline);
export default __webpack_public_path__ + "static/media/AnnotationOutline.dc2c46718ac90f858024ccfd9d8d0c9d.svg";
export { ForwardRef as ReactComponent };